module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-385.1403d5c.woff2";